import type { Fallacy } from "./types";
import { createStory } from "./types";

export const loadedQuestion: Fallacy = {
    id: "loaded-question",
    name: "Loaded Question",
    emoji: "🪤",
    category: "Menyerang Lawan",
    description:
      "Pertanyaan yang mengandung **asumsi tersembunyi**, sehingga **jawaban apa pun menjebak**.",
    tldr: "Pertanyaannya sudah mengandung tuduhan. Jawab iya salah, jawab tidak juga salah.",
    detail:
      "Loaded Question adalah pertanyaan yang mengandung **asumsi atau tuduhan tersembunyi**. Menjawab 'ya' atau 'tidak' sama-sama menjebak karena kamu secara tidak langsung menerima asumsi tersebut.\n\nContoh klasik: \"Kamu sudah berhenti mukul istri kamu?\" — menjawab 'ya' atau 'tidak' sama-sama mengakui pernah mukul. Pertanyaan mengandung premis yang belum terbukti, dan dengan menjawab, kamu implisit menerima premis itu.\n\nCara melawan: **Jangan langsung menjawab. Tantang asumsinya dulu.** \"Pertanyaan kamu mengandung asumsi yang salah. Saya tidak pernah...\"",
    story: createStory("Loaded Question", "🪤", {
      hook: {
        title: "Pertanyaannya udah mengandung tuduhan.",
        body: "Jawab iya salah. Jawab enggak juga salah. Kamu dijebak.",
      },
      convo: {
        claim: "Aku cerita baru dapet promosi, seneng banget. Eh langsung ditanya **\"jadi selama ini kamu kerja cuma buat jabatan doang?\"** Aku sampe bingung mau jawab apa.",
        response: "Pertanyaannya udah nganggep kamu materialistis. **Asumsinya disisipin, bukan ditanya.**",
      },
      reveal: {
        body: "Pertanyaannya mengandung **asumsi tersembunyi**. Dengan menjawab, kamu secara gak langsung **nerima asumsi** yang belum tentu bener.",
      },
      insight: {
        title: "Cara lawannya?",
        body: "**Jangan langsung jawab.** Tantang dulu asumsinya. Bilang aja: \"Pertanyaan kamu udah mengandung tuduhan yang belum tentu bener.\"",
      },
      engagement: {
        title: "Pernah kena loaded question yang bikin bingung?",
        body: "Dari temen, keluarga, atau bos? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["ad-hominem", "straw-man", "false-dilemma"],
  };
